import PrivilegiosForm from "./PrivilegiosForm";
export default PrivilegiosForm;